import murmur2 from '@emotion/hash';

// Something about Emotion’s build process causes the CJS option to load
// sometimes, so we handle both cases.
export const hash =
  (murmur2 as unknown as {default: typeof murmur2}).default || murmur2;
